var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Broadcast"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broadcast",
    clipPath: "url(#clip-Broadcast)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-69.064 0.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M72.755,68.14a.205.205,0,0,0,.106-.207l-.157-1.2,1.883,1.52a.205.205,0,1,0,.258-.319l-2.282-1.842a.205.205,0,0,0-.332.186l.154,1.178-2.048-1.774a.205.205,0,1,0-.269.31l2.456,2.127a.2.2,0,0,0,.231.026Z",
    transform: "translate(0 -64.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M424.88,65.7a.205.205,0,0,0-.29-.021l-2.048,1.774.154-1.178a.205.205,0,0,0-.332-.186l-2.282,1.842a.205.205,0,0,0,.258.319l1.884-1.52-.157,1.2h0a.205.205,0,0,0,.338.182l2.456-2.127a.205.205,0,0,0,.021-.289Z",
    transform: "translate(-341.8 -64.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M170.746,141.171a.206.206,0,0,0,.113.034h8a.205.205,0,0,0,.188-.288l-3.442-7.795a1.129,1.129,0,1,0-1.495,0l-3.442,7.8a.207.207,0,0,0,.075.253Zm7.732-.532-3.065-1.212,2.155-.849ZM177.09,137.5l-1.853-1.2,1.027-.667Zm-2.024-4.107a1.111,1.111,0,0,0,.188-.052l.842,1.908-1.03.669Zm0,3.281,1.928,1.253h-1.928Zm0,1.664h2.006l-2.006.79Zm0,1.4,2.691,1.065h-2.691Zm-.41,1.065H171.94l2.715-1.07Zm0-1.668-2.007-.794h2.007Zm0-1.2h-1.928l1.928-1.253Zm-.188-4.586a1.108,1.108,0,0,0,.188.052v2.525l-1.03-.669Zm-1.01,2.288,1.027.667-1.853,1.2Zm-1.3,2.954,2.143.848-3.048,1.2Z",
    transform: "translate(-98.296 -128.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M414.825,173.178a.584.584,0,0,1-.108.067v0h0a2.152,2.152,0,0,1-.622,1.195l.263.6a2.769,2.769,0,0,0,1-2.133c0-.052,0-.1-.005-.155Z",
    transform: "translate(-336.028 -168.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M402.45,193.074l.093.211a1.735,1.735,0,0,0,.374-.74h0a.61.61,0,0,1-.2-.086,1.536,1.536,0,0,1-.276.614Z",
    transform: "translate(-324.656 -187.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M432.57,156.79l.287.651h0l.135.308a4.206,4.206,0,0,0,1.842-3.276h0a.614.614,0,0,1-.906-.618l.025-.189-.173.14a3.294,3.294,0,0,1,.034.463,3.178,3.178,0,0,1-1.244,2.521Z",
    transform: "translate(-354.07 -150.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M277.4,192.554a1.735,1.735,0,0,0,.375.74l.093-.211a1.538,1.538,0,0,1-.276-.614.612.612,0,0,1-.2.086Z",
    transform: "translate(-202.53 -187.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M232.41,173.178l-.532-.429c0,.051-.005.1-.005.155a2.766,2.766,0,0,0,1,2.133l.263-.6a2.152,2.152,0,0,1-.622-1.2,1,1,0,0,1-.109-.069Z",
    transform: "translate(-158.08 -168.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M171.431,154.465a.615.615,0,0,1-.492.038h0a.616.616,0,0,1-.091-.04h0a4.206,4.206,0,0,0,1.842,3.276l.423-.959h0a3.178,3.178,0,0,1-1.244-2.521,3.293,3.293,0,0,1,.034-.463l-.173-.14.025.189a.616.616,0,0,1-.319.622Z",
    transform: "translate(-98.482 -150.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M200.766,1.877h0l.8.648h0a3.177,3.177,0,0,1,5.394,0l.578-.466h0l.225-.182a4.2,4.2,0,0,0-7,0Z",
    transform: "translate(-127.702 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M249.274,62.984a2.154,2.154,0,0,1,3.778,0h0l.483-.39h0a2.767,2.767,0,0,0-4.747,0l0,.006.481.389,0,0Z",
    transform: "translate(-174.598 -59.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M283.494,106.11a1.537,1.537,0,0,1,2.8,0,.629.629,0,0,1,.058-.054l.1-.083h0a1.74,1.74,0,0,0-3.127,0l.1.083a.629.629,0,0,1,.058.054Z",
    transform: "translate(-208.333 -102.532)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.b8c9941583d1a960b03c273423dc7e5e.svg";
export { ForwardRef as ReactComponent };